import { Dialog } from "@headlessui/react"
import { KTitleSpan, KSpan, KButton, KDropdown, KTooltip } from "kahuna-base-react-components"
import React, { useEffect, useState } from "react"
import { lang } from "../../../../../constants/languages"
import { User } from "../../../../../types"

const UserSummaryModal = ({
  linkList,
  setLinkList,
  user
}: {
  linkList?: string[]
  setLinkList: (linkList?: string[]) => void
  user: User
}) => {
  const onDownload = async (link: string) => {
    if (user?.hideReportTotalAmount) {
      // Fetch the CSV
      const response = await fetch(link)
      const text = await response.text()

      // Parse CSV
      const rows = text
        .trim()
        .split("\n")
        .map((r) => r.split(","))

      // Find Total Amount column index
      const header = rows[0].map((h) => h.replace("\r", "").trim())
      const totalAmountIndex = header.indexOf("Total Amount")

      // Remove the column if it exists
      let newRows = rows
      if (totalAmountIndex !== -1) {
        newRows = rows.map((row) => row.filter((_, i) => i !== totalAmountIndex))
      }

      // Rebuild CSV
      const newCsv = newRows.map((r) => r.join(",")).join("\n")

      // Trigger download
      const blob = new Blob([newCsv], { type: "text/csv;charset=utf-8;" })
      const fileName = link.split("/").pop() || "report.csv"
      const linkElement = document.createElement("a")
      linkElement.href = URL.createObjectURL(blob)
      linkElement.setAttribute("download", fileName)
      document.body.appendChild(linkElement)
      linkElement.click()
      document.body.removeChild(linkElement)
    } else {
      // Open normally if no hiding
      window.open(link, "_blank")
    }
  }

  return (
    <Dialog open={linkList !== undefined} onClose={() => setLinkList(undefined)}>
      <div className="fixed w-screen h-screen top-0 left-0 z-250 flex items-center justify-center bg-[#0000004d] ">
        <div className="p-6 shadow-md w-[360px] rounded-[10px] bg-[#fff]">
          <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-6 items-center justify-center">
              <span
                className="w-[72px] aspect-square rounded-full flex justify-center items-center"
                style={{
                  border: "1px solid #F3F3F3"
                }}
              >
                <img className="w-8 h-8" src="/account_icons/music-note-sparkle-filled.svg" />
              </span>
              <KTitleSpan
                text={lang.reports.list_component.click_to_download}
                fontSize={20}
                lineHeight="28px"
                color="#000"
              />
            </div>
            <div className="flex flex-col gap-2 mt-4">
              {linkList?.map((link, index) => {
                const linkSplited = link.split("/")
                return (
                  <div key={`${index}_link_royalty_report`}>
                    <KButton
                      text={linkSplited[linkSplited.length - 1]}
                      onClick={() => onDownload(link)}
                      shadowDisabled={true}
                      background="transparent"
                    />
                  </div>
                )
              })}
            </div>
            <div className="mt-4 justify-end flex">
              <KButton text={lang.common.close} onClick={() => setLinkList(undefined)} background="transparent" />
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default UserSummaryModal
